import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import './Component_ShortUrlEditor.scss';
import { TS_EditableContent, TS_EditableItemStatus } from '@nu-art/thunderstorm-frontend/editable-item';
import { Button, LL_H_C, ModuleFE_Thunderstorm, TS_Card, TS_PropRenderer } from '@nu-art/thunderstorm-frontend/index';
import { TS_InputV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_Input/index';
import { TS_Icons } from '@nu-art/ts-styles';
import { TS_TextAreaV2 } from '@nu-art/thunderstorm-frontend/components/TS_V2_TextArea/index';
import { ModuleFE_ShortUrl } from '../../../_entity/short-url/index.js';
const StringEditableInput = TS_InputV2.editable({
    type: 'text',
    saveEvent: ['blur', 'accept']
});
const TextArea = TS_TextAreaV2.editable({
    saveEvent: ['blur', 'accept']
});
export class Component_ShortUrlEditor extends TS_EditableContent {
    deriveStateFromProps(nextProps, state) {
        state = super.deriveStateFromProps(nextProps, state);
        return state;
    }
    render() {
        const _id = this.state.editable.get('_id');
        return _jsxs(TS_Card, { className: 'short-url-editor', children: [_jsxs(LL_H_C, { className: 'utils', children: [_jsx(TS_EditableItemStatus, { editable: this.state.editable }), _jsx(TS_Icons.x.component, { onClick: async () => {
                                if (this.state.editable.get('_id'))
                                    await this.state.editable.delete();
                                this.props.deleteCallback?.();
                            } })] }), _jsxs(LL_H_C, { children: [_jsx(TS_PropRenderer.Vertical, { label: 'Title', children: _jsx(StringEditableInput, { editable: this.state.editable, prop: 'title', onChange: value => {
                                    if (value.length)
                                        return this.state.editable.updateObj({ title: value });
                                    return this.state.editable.updateObj({ title: undefined });
                                } }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Short Url', children: _jsx("div", { children: this.state.editable.item._shortUrl }) })] }), _jsx(TS_PropRenderer.Vertical, { label: 'Full Url', children: _jsx(TextArea, { editable: this.state.editable, prop: 'fullUrl', className: 'url-input', onChange: value => {
                            if (value.length)
                                return this.state.editable.updateObj({ fullUrl: value });
                            return this.state.editable.updateObj({ fullUrl: undefined });
                        } }) }), _jsx(TS_PropRenderer.Vertical, { label: 'Description', children: _jsx(TextArea, { editable: this.state.editable, prop: 'description', onChange: value => {
                            if (value?.length)
                                return this.state.editable.updateObj({ description: value });
                            return this.state.editable.updateObj({ description: undefined });
                        } }) }), _jsxs(LL_H_C, { className: 'buttons-container', children: [_jsx(Button, { variant: 'tertiary', disabled: !_id, onClick: async () => {
                                const { shortUrl } = await ModuleFE_ShortUrl._v1.getShortUrl({ _id: _id }).executeSync();
                                await ModuleFE_Thunderstorm.copyToClipboard(shortUrl);
                            }, children: "Copy ShortUrl To Clipboard" }), _jsx(Button, { variant: 'primary', onClick: async () => {
                                await this.state.editable.save();
                            }, children: "Save" })] })] });
    }
}
//# sourceMappingURL=Component_ShortUrlEditor.js.map